import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Shield } from 'lucide-react';
const audienceItems = [{
  title: 'Profesionales estancados:',
  desc: 'Arquitectos, diseñadores y constructores intermedios y avanzados que visitan muchas obras pero cierran pocos contratos.'
}, {
  title: 'Trabajás por tu cuenta o con cuadrillas:',
  desc: 'Desde reformas de baños y cocinas hasta remodelaciones integrales de viviendas y locales.'
}, {
  title: 'Buscás optimizar tus tiempos:',
  desc: 'Querés dejar de pasar tus noches frente a la computadora armando presupuestos y planillas desde cero.'
}, {
  title: 'Querés triplicar tus cierres:',
  desc: 'Vas por clientes de alto valor que exigen una presentación profesional, formal y transparente.'
}];
export function Audience() {
  return <section className="py-10 sm:py-16 lg:py-24 bg-amber-50 border-y border-amber-100" data-id="element-2">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
        <div className="text-center mb-8 sm:mb-12" data-id="element-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-3 sm:mb-4 text-[#2955A0]" data-id="element-5">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-base sm:text-lg text-gray-600" data-id="element-6">
            Diseñado para vos si querés llevar tu negocio de remodelaciones al
            próximo nivel:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8 mb-8 sm:mb-12" data-id="element-7">
          {audienceItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-5 sm:p-8 rounded-2xl shadow-sm border border-gray-100 flex items-start hover:shadow-md transition-shadow" data-id="element-8">
              <CheckCircle2 className="w-6 h-6 sm:w-8 sm:h-8 text-green-500 mr-3 sm:mr-4 flex-shrink-0 mt-0.5" data-id="element-9" />
              <div data-id="element-10">
                <h3 className="font-bold text-brand-dark text-base sm:text-lg mb-1 sm:mb-2" data-id="element-11">
                  {item.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed" data-id="element-12">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-13">
          <a href="#pricing" className="inline-flex items-center text-sm sm:text-base text-brand-dark font-medium hover:text-brand-accent transition-colors" data-id="element-14">
            <Shield className="w-4 h-4 mr-2 text-green-600" data-id="element-15" />
            ¿No estás seguro si es para vos? Tenés 7 días de garantía →
          </a>
        </div>
      </div>
    </section>;
}